export default {
  computed: {
    bridgeTypesIcons() {
      return {
        'bridge-niota': './img/bridges/niota.png',
        'bridge-mqtt': './img/bridges/mqtt.png',
        'ng-bridge-mqtt': './img/bridges/mqtt.png',
        'bridge-openweather': './img/bridges/OpenWeatherMap_logo.png',
        'bridge-thingsstack': './img/bridges/thingsstack.png',
        'bridge-firefly': './img/bridges/firefly.png',
        'bridge-incomingwebhook': './img/bridges/incomingwebhook.png',
        'bridge-loriot': './img/bridges/loriot.png',
        'bridge-chirpstack': './img/bridges/chirpstack.png',
        'bridge-wireless-mbus-decoder': './img/bridges/wireless-mbus-decoder.png',
        'bridge-lwm2m-server': './img/bridges/lwm2m-server.png',
      };
    },
  },
};
